import React from 'react';
import propTypes from 'prop-types';

const UserName = props => {

    const {nameClass, name} = props;

    return (
        <span className={nameClass}>{name}</span>

    )

};

UserName.propTypes = {
    nameClass: propTypes.string,
    name: propTypes.string.isRequired
};

UserName.defaultProps = {
    name: 'Tom Smith'
};

export default UserName;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/UserName.js